import { render } from "./UserCardVIew.vue?vue&type=template&id=2d015ce2&scoped=true"
import script from "./UserCardVIew.vue?vue&type=script&lang=js"
export * from "./UserCardVIew.vue?vue&type=script&lang=js"

import "./UserCardVIew.vue?vue&type=style&index=0&id=2d015ce2&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d015ce2"]])

export default __exports__